module.exports = __webpack_public_path__ + "media/images/icon_tab1_off-9fa604582c19eaa2310d988903b10c2a.png";